import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var serialize = function serialize(data) {
  return JSON.parse(JSON.stringify(data, function (_key, value) {
    return value === null ? undefined : value;
  }));
};
var mergeProduct = function mergeProduct(lineItem, product) {
  return _objectSpread(_objectSpread(_objectSpread({}, lineItem), product), {}, {
    variant: _objectSpread(_objectSpread({}, lineItem === null || lineItem === void 0 ? void 0 : lineItem.variant), product === null || product === void 0 ? void 0 : product.variant)
  });
};
export var serializeMeta = function serializeMeta(config) {
  return {
    meta: {
      i18n: {
        locale: config.locale,
        currency: config.currency
      },
      ownership: {
        tenant_id: config.tenantId,
        oms_id: config.omsId,
        store_id: config.storeId
      }
    }
  };
};
export var getLineItemCoupon = function getLineItemCoupon(lineItem) {
  var _lineItem$adjustments, _eligible$promotionCo;
  var eligible = (_lineItem$adjustments = lineItem.adjustments) === null || _lineItem$adjustments === void 0 ? void 0 : _lineItem$adjustments.find(function (adjustment) {
    var _adjustment$promotion;
    return (adjustment === null || adjustment === void 0 ? void 0 : adjustment.eligible) && (adjustment === null || adjustment === void 0 ? void 0 : (_adjustment$promotion = adjustment.promotionCode) === null || _adjustment$promotion === void 0 ? void 0 : _adjustment$promotion.value);
  });
  return eligible === null || eligible === void 0 ? void 0 : (_eligible$promotionCo = eligible.promotionCode) === null || _eligible$promotionCo === void 0 ? void 0 : _eligible$promotionCo.value;
};
export var subscriptionLineItemToProduct = function subscriptionLineItemToProduct(lineItem) {
  return {
    displayAmount: lineItem.displayPrice,
    price: lineItem.price,
    quantity: lineItem.quantity,
    variant: {
      description: lineItem.description,
      id: lineItem.variantId,
      images: lineItem.images,
      name: lineItem.name,
      price: lineItem.price,
      sku: lineItem.sku,
      slug: lineItem.productSlug
    },
    variantId: lineItem.variantId
  };
};
export var serializeLineItem = function serializeLineItem(config, lineItem, position, expandOptionValues) {
  var _lineItem$variant, _lineItem$variant$opt, _lineItem$variant2, _lineItem$variant3, _lineItem$parts, _lineItem$variant4, _lineItem$variant5, _lineItem$variant6, _lineItem$variant6$st, _lineItem$variant7, _lineItem$variant7$im, _lineItem$variant7$im2, _lineItem$variant8, _lineItem$variant8$im, _lineItem$variant8$im2, _lineItem$variant9, _lineItem$variant9$im, _lineItem$variant9$im2, _lineItem$variant10, _lineItem$variant11, _lineItem$variant12, _lineItem$variant13;
  var lineItemId;
  var optionValues = (_lineItem$variant = lineItem.variant) === null || _lineItem$variant === void 0 ? void 0 : (_lineItem$variant$opt = _lineItem$variant.optionValues) === null || _lineItem$variant$opt === void 0 ? void 0 : _lineItem$variant$opt.map(function (value) {
    if (!expandOptionValues) return value === null || value === void 0 ? void 0 : value.name;
    var optionTypeName;
    if ('optionTypeName' in value) {
      optionTypeName = value.optionTypeName;
    } else if ('optiontypeName' in value) {
      optionTypeName = value.optiontypeName;
    }
    return {
      name: "".concat(value === null || value === void 0 ? void 0 : value.presentation, " Option Value"),
      presentation: value === null || value === void 0 ? void 0 : value.presentation,
      slug: value === null || value === void 0 ? void 0 : value.name,
      option_type: [{
        slug: optionTypeName
      }]
    };
  });
  if ('id' in lineItem && lineItem.id) {
    lineItemId = lineItem.id.toString();
  }
  var url = '';
  try {
    var formatted = config.productUrlFormatter(lineItem);
    if (formatted) url = String(formatted);
  } catch (error) {
    console.error('productUrlFormatter error', error);
  }
  // Kits are bundles by the tracking plan definition and can be detected if the
  // sku contains a pipe character.
  var bundle = ((_lineItem$variant2 = lineItem.variant) === null || _lineItem$variant2 === void 0 ? void 0 : _lineItem$variant2.sku.indexOf('|')) >= 0;
  // If not a kit, check to see if bundle. Kits are not bundles by the OMS
  // defintion BUT are bundles by the tracking plan definition.
  if (!bundle && 'isBundle' in lineItem && typeof lineItem.isBundle === 'boolean') {
    bundle = lineItem.isBundle;
  }

  // Consolidates pack/kit data reported to GA4.
  var name = (_lineItem$variant3 = lineItem.variant) === null || _lineItem$variant3 === void 0 ? void 0 : _lineItem$variant3.name.replace(/( (6|12|18|24)( |-)(pack|Pack))/gm, ' Pack');
  var canQuantity = ((_lineItem$parts = lineItem.parts) === null || _lineItem$parts === void 0 ? void 0 : _lineItem$parts.length) && lineItem.parts.reduce(function (canCount, part) {
    var _part$variant;
    return ((_part$variant = part.variant) === null || _part$variant === void 0 ? void 0 : _part$variant.weight) == '9.3' ? canCount + part.quantity : canCount;
  }, 0);
  var quantity = canQuantity ? parseInt(canQuantity * lineItem.quantity / 6) : lineItem.quantity;
  var price = canQuantity ? parseFloat(((_lineItem$variant4 = lineItem.variant) === null || _lineItem$variant4 === void 0 ? void 0 : _lineItem$variant4.price) / quantity) : parseFloat((_lineItem$variant5 = lineItem.variant) === null || _lineItem$variant5 === void 0 ? void 0 : _lineItem$variant5.price);
  return {
    brand: ((_lineItem$variant6 = lineItem.variant) === null || _lineItem$variant6 === void 0 ? void 0 : (_lineItem$variant6$st = _lineItem$variant6.store) === null || _lineItem$variant6$st === void 0 ? void 0 : _lineItem$variant6$st.slug) || config.brandName,
    coupon: getLineItemCoupon(lineItem) || '',
    image_url: ((_lineItem$variant7 = lineItem.variant) === null || _lineItem$variant7 === void 0 ? void 0 : (_lineItem$variant7$im = _lineItem$variant7.images) === null || _lineItem$variant7$im === void 0 ? void 0 : (_lineItem$variant7$im2 = _lineItem$variant7$im[0]) === null || _lineItem$variant7$im2 === void 0 ? void 0 : _lineItem$variant7$im2.largeUrl) || ((_lineItem$variant8 = lineItem.variant) === null || _lineItem$variant8 === void 0 ? void 0 : (_lineItem$variant8$im = _lineItem$variant8.images) === null || _lineItem$variant8$im === void 0 ? void 0 : (_lineItem$variant8$im2 = _lineItem$variant8$im[0]) === null || _lineItem$variant8$im2 === void 0 ? void 0 : _lineItem$variant8$im2.smallUrl) || ((_lineItem$variant9 = lineItem.variant) === null || _lineItem$variant9 === void 0 ? void 0 : (_lineItem$variant9$im = _lineItem$variant9.images) === null || _lineItem$variant9$im === void 0 ? void 0 : (_lineItem$variant9$im2 = _lineItem$variant9$im[0]) === null || _lineItem$variant9$im2 === void 0 ? void 0 : _lineItem$variant9$im2.miniUrl),
    name: name,
    option_values: optionValues,
    bundle: bundle,
    description: (_lineItem$variant10 = lineItem.variant) === null || _lineItem$variant10 === void 0 ? void 0 : _lineItem$variant10.description,
    position: position,
    price: price,
    product_id: (_lineItem$variant11 = lineItem.variant) === null || _lineItem$variant11 === void 0 ? void 0 : _lineItem$variant11.slug,
    quantity: quantity,
    sku: (_lineItem$variant12 = lineItem.variant) === null || _lineItem$variant12 === void 0 ? void 0 : _lineItem$variant12.sku,
    url: url,
    variant: (_lineItem$variant13 = lineItem.variant) === null || _lineItem$variant13 === void 0 ? void 0 : _lineItem$variant13.sku,
    line_item_id: lineItemId
  };
};
var serializeLineItems = function serializeLineItems(config, lineItems, products) {
  return lineItems.map(function (lineItem, index) {
    var product = products === null || products === void 0 ? void 0 : products.find(function (p) {
      var _p$variant, _lineItem$variant14;
      return ((_p$variant = p.variant) === null || _p$variant === void 0 ? void 0 : _p$variant.sku) === ((_lineItem$variant14 = lineItem.variant) === null || _lineItem$variant14 === void 0 ? void 0 : _lineItem$variant14.sku);
    });
    var data = product ? mergeProduct(lineItem, product) : lineItem;
    return serializeLineItem(config, data, index + 1);
  });
};
export var serializeCouponItem = function serializeCouponItem(config, props) {
  var couponCode = props.couponCode,
    order = props.order;
  return _objectSpread({
    cart_id: order.number,
    coupon_id: couponCode,
    order_id: order.number
  }, serializeMeta(config));
};
export var serializeSubscription = function serializeSubscription(config, props) {
  var _subscription$shipAdd, _subscription$shipAdd2, _subscription$shipAdd3, _subscription$shipAdd4, _subscription$shipAdd5, _subscription$shipAdd6, _subscription$shipAdd7;
  var products = props.products,
    subscription = props.subscription;
  var subscriptionProducts = subscription.lineItems.map(function (lineItem, index) {
    var product = products === null || products === void 0 ? void 0 : products.find(function (p) {
      var _p$variant2;
      return ((_p$variant2 = p.variant) === null || _p$variant2 === void 0 ? void 0 : _p$variant2.sku) === lineItem.sku;
    });
    var subscriptionLineItem = subscriptionLineItemToProduct(lineItem);
    var data = product ? mergeProduct(subscriptionLineItem, product) : subscriptionLineItem;
    return serializeLineItem(config, data, index + 1);
  });
  return serialize(_objectSpread({
    id: subscription.id,
    brand: config.brandName,
    state: subscription.state,
    interval_units: subscription.intervalUnits,
    interval_length: subscription.intervalLength,
    end_date: subscription.endDate,
    actionable_date: subscription.actionableDate,
    products: subscriptionProducts,
    address: {
      name: (_subscription$shipAdd = subscription.shipAddress) === null || _subscription$shipAdd === void 0 ? void 0 : _subscription$shipAdd.name,
      address1: (_subscription$shipAdd2 = subscription.shipAddress) === null || _subscription$shipAdd2 === void 0 ? void 0 : _subscription$shipAdd2.address1,
      address2: (_subscription$shipAdd3 = subscription.shipAddress) === null || _subscription$shipAdd3 === void 0 ? void 0 : _subscription$shipAdd3.address2,
      city: (_subscription$shipAdd4 = subscription.shipAddress) === null || _subscription$shipAdd4 === void 0 ? void 0 : _subscription$shipAdd4.city,
      country: (_subscription$shipAdd5 = subscription.shipAddress) === null || _subscription$shipAdd5 === void 0 ? void 0 : _subscription$shipAdd5.country.iso,
      state: (_subscription$shipAdd6 = subscription.shipAddress) === null || _subscription$shipAdd6 === void 0 ? void 0 : _subscription$shipAdd6.state.abbr,
      zipcode: (_subscription$shipAdd7 = subscription.shipAddress) === null || _subscription$shipAdd7 === void 0 ? void 0 : _subscription$shipAdd7.zipcode
    }
  }, serializeMeta(config)));
};
export var serializeCartViewed = function serializeCartViewed(config, props) {
  var _order$store;
  var order = props.order,
    products = props.products;
  return serialize(_objectSpread({
    brand: (_order$store = order.store) === null || _order$store === void 0 ? void 0 : _order$store.name,
    cart_id: order.number,
    products: serializeLineItems(config, order.lineItems, products)
  }, serializeMeta(config)));
};
export var serializeCheckoutCompleted = function serializeCheckoutCompleted(config, props) {
  var _couponAdjustment$pro;
  var order = props.order,
    products = props.products,
    trackingIds = props.trackingIds;
  var couponAdjustment = props.order.lineItems.map(function (lineItem) {
    return lineItem.adjustments;
  }).flat().find(function (adjustment) {
    return adjustment.promotionCode;
  });
  var serializedProducts = serializeLineItems(config, order.lineItems, products).map(function (product) {
    var _lineItem$variant15;
    var lineItem = order.lineItems.find(function (i) {
      var _i$variant;
      return ((_i$variant = i.variant) === null || _i$variant === void 0 ? void 0 : _i$variant.sku) === product.sku;
    });
    return _objectSpread(_objectSpread({}, product), {}, {
      name: (_lineItem$variant15 = lineItem.variant) === null || _lineItem$variant15 === void 0 ? void 0 : _lineItem$variant15.slug,
      price: lineItem.price,
      total: lineItem.total
    });
  });
  return serialize(_objectSpread({
    value: parseFloat(order.total),
    currency: 'USD',
    transaction_id: order.number,
    discount: parseFloat(order.additionalTaxTotal) - parseFloat(order.adjustmentTotal),
    email_hash: order.email,
    store: order.store.code,
    tracking_ids: trackingIds !== null && trackingIds !== void 0 ? trackingIds : {},
    coupon: couponAdjustment === null || couponAdjustment === void 0 ? void 0 : (_couponAdjustment$pro = couponAdjustment.promotionCode) === null || _couponAdjustment$pro === void 0 ? void 0 : _couponAdjustment$pro.value,
    products: serializedProducts
  }, serializeMeta(config)));
};
export var serializeCheckoutStarted = function serializeCheckoutStarted(config, props) {
  var _order$store2, _couponAdjustment$pro2;
  var order = props.order,
    products = props.products;
  var couponAdjustment = order.lineItems.map(function (lineItem) {
    return lineItem.adjustments;
  }).flat().find(function (adjustment) {
    return adjustment.promotionCode;
  });
  return serialize(_objectSpread({
    affiliation: (_order$store2 = order.store) === null || _order$store2 === void 0 ? void 0 : _order$store2.name,
    order_id: order.number,
    currency: order.currency,
    revenue: parseFloat(order.total),
    discount: parseFloat(order.additionalTaxTotal) - parseFloat(order.adjustmentTotal),
    shipping: parseFloat(order.shipTotal),
    tax: parseFloat(order.taxTotal),
    total: parseFloat(order.total),
    coupon: couponAdjustment === null || couponAdjustment === void 0 ? void 0 : (_couponAdjustment$pro2 = couponAdjustment.promotionCode) === null || _couponAdjustment$pro2 === void 0 ? void 0 : _couponAdjustment$pro2.value,
    products: serializeLineItems(config, order.lineItems, products)
  }, serializeMeta(config)));
};
export var serializeCollectionClicked = function serializeCollectionClicked(config, props) {
  var collection = props.collection;
  return serialize(_objectSpread({
    brand: collection.brand || config.brandName,
    collection_id: collection.collectionId,
    title: collection.title,
    url: collection.url
  }, serializeMeta(config)));
};
export var serializeEmailCaptured = function serializeEmailCaptured(config, props) {
  var emailCapture = props.emailCapture;
  return serialize(_objectSpread({
    email: emailCapture.email,
    web_placement: {
      component: emailCapture.component,
      page: emailCapture.page,
      website: emailCapture.website
    }
  }, serializeMeta(config)));
};
export var serializeOrderCompleted = function serializeOrderCompleted(config, props) {
  var _couponAdjustment$pro3;
  var order = props.order,
    products = props.products,
    trackingIds = props.trackingIds;
  var couponAdjustment = order.lineItems.map(function (lineItem) {
    return lineItem.adjustments;
  }).flat().find(function (adjustment) {
    return adjustment.promotionCode;
  });
  var serializedProducts = serializeLineItems(config, order.lineItems, products).map(function (product) {
    var _lineItem$variant16;
    var lineItem = order.lineItems.find(function (i) {
      var _i$variant2;
      return ((_i$variant2 = i.variant) === null || _i$variant2 === void 0 ? void 0 : _i$variant2.sku) === product.sku;
    });
    return _objectSpread(_objectSpread({}, product), {}, {
      variant: (_lineItem$variant16 = lineItem.variant) === null || _lineItem$variant16 === void 0 ? void 0 : _lineItem$variant16.optionsText
    });
  });
  return serialize(_objectSpread({
    affiliation: config.brandName,
    coupon: couponAdjustment === null || couponAdjustment === void 0 ? void 0 : (_couponAdjustment$pro3 = couponAdjustment.promotionCode) === null || _couponAdjustment$pro3 === void 0 ? void 0 : _couponAdjustment$pro3.value,
    order_id: order.id,
    order_date: order.completedAt,
    total: parseFloat(order.total) || 0,
    shipping: parseFloat(order.shipTotal) || 0,
    tax: parseFloat(order.taxTotal) || 0,
    currency: 'USD',
    transaction_id: order.number,
    discount: parseFloat(order.additionalTaxTotal) - parseFloat(order.adjustmentTotal),
    email: order.email,
    email_hash: order.email,
    store: order.store.code,
    tracking_ids: trackingIds !== null && trackingIds !== void 0 ? trackingIds : {},
    // Requested by VIDEN Media for conversion tracking in GA4.
    user_id: order.userId,
    revenue: parseFloat(order.total) || 0,
    products: serializedProducts,
    has_subscription: !!order.subscriptionInCart,
    is_recurring: false
  }, serializeMeta(config)));
};
export var serializeProductAdded = function serializeProductAdded(config, props) {
  var order = props.order,
    product = props.product,
    sku = props.sku,
    quantity = props.quantity;
  var lineItem = sku && order.lineItems.find(function (item) {
    var _item$variant;
    return ((_item$variant = item.variant) === null || _item$variant === void 0 ? void 0 : _item$variant.sku) === sku;
  });
  var data = product ? mergeProduct(lineItem, product) : lineItem;
  var serializedLineItem = serializeLineItem(config, data, undefined, true);
  return serialize(_objectSpread(_objectSpread(_objectSpread({}, serializedLineItem), serializeMeta(config)), {}, {
    cart_id: order.number
  }));
};
export var serializeProductClicked = function serializeProductClicked(config, props) {
  var order = props.order,
    product = props.product;
  return serialize(_objectSpread(_objectSpread(_objectSpread({}, serializeLineItem(config, product)), serializeMeta(config)), {}, {
    cart_id: order.number
  }));
};
export var serializeProductRemoved = function serializeProductRemoved(config, props) {
  var _lineItem$subscriptio;
  var order = props.order,
    product = props.product,
    sku = props.sku,
    quantity = props.quantity;
  var lineItem = sku && order.lineItems.find(function (item) {
    var _item$variant2;
    return ((_item$variant2 = item.variant) === null || _item$variant2 === void 0 ? void 0 : _item$variant2.sku) === sku;
  });
  var data = product ? mergeProduct(lineItem, product) : lineItem;
  var serializedLineItem = serializeLineItem(config, data, undefined, true);
  var subscriptionRelatedFields = {};
  if (lineItem !== null && lineItem !== void 0 && (_lineItem$subscriptio = lineItem.subscriptionLineItems) !== null && _lineItem$subscriptio !== void 0 && _lineItem$subscriptio.length) {
    var subscriptionLineItem = lineItem.subscriptionLineItems[0];
    subscriptionRelatedFields = _objectSpread(_objectSpread({}, subscriptionRelatedFields), {}, {
      prepaid: false,
      interval_units: subscriptionLineItem.intervalUnits,
      interval_length: subscriptionLineItem.intervalLength
    });
  }
  return serialize(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, serializedLineItem), serializeMeta(config)), subscriptionRelatedFields), {}, {
    cart_id: order.number
  }));
};
export var serializeProductViewed = function serializeProductViewed(config, props) {
  var order = props.order,
    product = props.product;
  return serialize(_objectSpread(_objectSpread(_objectSpread({}, serializeLineItem(config, product)), serializeMeta(config)), {}, {
    cart_id: order.number
  }));
};
export var serializeStockRequestCreated = function serializeStockRequestCreated(config, props) {
  var order = props.order,
    product = props.product,
    email = props.email;
  return serialize(_objectSpread(_objectSpread(_objectSpread({}, serializeLineItem(config, product, undefined, true)), serializeMeta(config)), {}, {
    cart_id: order.number,
    email: email
  }));
};
export var serializeVariantClicked = function serializeVariantClicked(config, props) {
  var _product$variant, _product$variant2;
  var order = props.order,
    product = props.product;
  return serialize(_objectSpread(_objectSpread(_objectSpread({}, serializeLineItem(config, product)), serializeMeta(config)), {}, {
    cart_id: order.number,
    variant: (_product$variant = product.variant) === null || _product$variant === void 0 ? void 0 : _product$variant.name,
    variant_id: (_product$variant2 = product.variant) === null || _product$variant2 === void 0 ? void 0 : _product$variant2.sku
  }));
};
export var serializeUnpurchasedSubscription = function serializeUnpurchasedSubscription(config, props) {
  var _subscriptionLineItem, _subscriptionLineItem2, _subscriptionLineItem3, _subscriptionLineItem4, _subscriptionLineItem5, _subscriptionLineItem6;
  var order = props.order,
    lineItem = props.lineItem,
    subscriptionLineItem = props.subscriptionLineItem,
    product = props.product;
  var data = product ? mergeProduct(lineItem, product) : lineItem;
  var serializedLineItem = serializeLineItem(config, data, undefined, true);
  return _objectSpread(_objectSpread({}, serializedLineItem), {}, {
    cart_id: order.number,
    quantity: subscriptionLineItem.quantity,
    sku: subscriptionLineItem.sku,
    actionable_date: new Date().toISOString(),
    end_date: subscriptionLineItem.endDate,
    image_url: ((_subscriptionLineItem = subscriptionLineItem.images) === null || _subscriptionLineItem === void 0 ? void 0 : (_subscriptionLineItem2 = _subscriptionLineItem[0]) === null || _subscriptionLineItem2 === void 0 ? void 0 : _subscriptionLineItem2.largeUrl) || ((_subscriptionLineItem3 = subscriptionLineItem.images) === null || _subscriptionLineItem3 === void 0 ? void 0 : (_subscriptionLineItem4 = _subscriptionLineItem3[0]) === null || _subscriptionLineItem4 === void 0 ? void 0 : _subscriptionLineItem4.smallUrl) || ((_subscriptionLineItem5 = subscriptionLineItem.images) === null || _subscriptionLineItem5 === void 0 ? void 0 : (_subscriptionLineItem6 = _subscriptionLineItem5[0]) === null || _subscriptionLineItem6 === void 0 ? void 0 : _subscriptionLineItem6.miniUrl),
    interval_length: subscriptionLineItem.intervalLength,
    interval_units: subscriptionLineItem.intervalUnits,
    name: subscriptionLineItem.name,
    prepaid: false,
    price: Number(lineItem.price)
  }, serializeMeta(config));
};
var addInstallmentIntervalToDate = function addInstallmentIntervalToDate(_ref) {
  var _ref$date = _ref.date,
    originalDate = _ref$date === void 0 ? new Date() : _ref$date,
    unit = _ref.unit,
    length = _ref.length,
    installments = _ref.installments;
  var intervalFactor = length * installments;
  var date = new Date(originalDate.getTime());
  switch (unit) {
    case 'day':
      return new Date(date.setDate(date.getDate() + intervalFactor));
    case 'week':
      return new Date(date.setDate(date.getDate() + intervalFactor * 7));
    case 'month':
      return new Date(date.setMonth(date.getMonth() + intervalFactor));
    case 'year':
      return new Date(date.setFullYear(date.getFullYear() + intervalFactor));
    default:
      throw new Error("unsupport unit provided (".concat(unit, ")"));
  }
};
export var serializePrepaidSubscription = function serializePrepaidSubscription(config, props) {
  var _lineItem$variant$ima, _lineItem$variant$ima2, _lineItem$variant$ima3, _lineItem$variant$ima4, _lineItem$variant$ima5, _lineItem$variant$ima6;
  var order = props.order,
    lineItem = props.lineItem,
    prepaidSubscription = props.prepaidSubscription,
    product = props.product;
  var actionableDate = new Date();
  if (typeof prepaidSubscription.actionableDate === 'string') {
    actionableDate = new Date(prepaidSubscription.actionableDate);
  } else if (prepaidSubscription.actionableDate) {
    actionableDate = prepaidSubscription.actionableDate;
  }
  var endDate = addInstallmentIntervalToDate({
    date: actionableDate,
    unit: prepaidSubscription.intervalUnits,
    length: prepaidSubscription.intervalLength,
    installments: prepaidSubscription.installmentCount
  });
  var data = product ? mergeProduct(lineItem, product) : lineItem;
  var serializedLineItem = serializeLineItem(config, data, undefined, true);
  return _objectSpread(_objectSpread({}, serializedLineItem), {}, {
    cart_id: order.number,
    quantity: prepaidSubscription.quantity,
    actionable_date: actionableDate.toISOString(),
    end_date: endDate.toISOString(),
    image_url: ((_lineItem$variant$ima = lineItem.variant.images) === null || _lineItem$variant$ima === void 0 ? void 0 : (_lineItem$variant$ima2 = _lineItem$variant$ima[0]) === null || _lineItem$variant$ima2 === void 0 ? void 0 : _lineItem$variant$ima2.largeUrl) || ((_lineItem$variant$ima3 = lineItem.variant.images) === null || _lineItem$variant$ima3 === void 0 ? void 0 : (_lineItem$variant$ima4 = _lineItem$variant$ima3[0]) === null || _lineItem$variant$ima4 === void 0 ? void 0 : _lineItem$variant$ima4.smallUrl) || ((_lineItem$variant$ima5 = lineItem.variant.images) === null || _lineItem$variant$ima5 === void 0 ? void 0 : (_lineItem$variant$ima6 = _lineItem$variant$ima5[0]) === null || _lineItem$variant$ima6 === void 0 ? void 0 : _lineItem$variant$ima6.miniUrl),
    installment_count: prepaidSubscription.installmentCount,
    interval_length: prepaidSubscription.intervalLength,
    interval_units: prepaidSubscription.intervalUnits,
    prepaid: true,
    price: Number(lineItem.price)
  }, serializeMeta(config));
};